export default "__VITE_ASSET__DU2La2Ik__"